import API from '@/api/callApi.js';
import endpoints from '@/api/endpoints';

function getTokenTTL(token) {
    let token_payload = token.split('.')[1];
    token_payload = JSON.parse(atob(token_payload));
    let now = new Date();
    now = Math.round(now.getTime() / 1000);
    let ttl = token_payload.exp - now;
    return ttl;
}

function getTokenDecodedPayload(token) {
    let token_payload = token.split('.')[1];
    return JSON.parse(atob(token_payload));
}

export default {
    namespaced: true,
    state: {
        applicationReady: false,
        users: {
            loading: false,
            loaded: false,
            error: null,
            data: [],
            cookie: null,
            loaded: false
        },
        passwordRequest: false
    },
    mutations: {
        setApplicationStatus(state, value) {
            state.applicationReady = value;
        },
        setUsersError(state, value) {
            state.users.error = value;
        },
        setUsersLoaded(state, value) {
            state.users.loaded = value;
        },
        setUsersData(state, value) {
            state.users.data = value;
        },
        storeTokenInCookie(state, token) {
            let payload = getTokenDecodedPayload(token);
            let expire_date = new Date(payload.exp * 1000);
            // let ttl = getTokenTTL(token);
            // let expire_date = new Date();
            // expire_date.setSeconds(expire_date.getSeconds() + ttl);
            // let dateSecondsTtl =  expire_date.getSeconds()+ttl;
            // let finalDateSeconds = expire_date.setSeconds(dateSecondsTtl);
            $cookies.set(process.env.VUE_APP_COOKIE_NAME, token, expire_date);
            state.users.cookie = token;
        },
        logoutUser() {
            $cookies.remove(process.env.VUE_APP_COOKIE_NAME);
            window.location.reload();
            return false;
        },
        setPasswordRequest(state, value) {
            state.passwordRequest = value;
        }
    },
    actions: {
        userData({commit}) {
            API.makeGet(endpoints.baseURL + endpoints.endpoints.me, null, true).then(response => {
                commit('setUsersLoaded', true);
                commit('setUsersData', response.data.payload);
            });
        },

        updateManager(
            {
                commit,
                dispatch
            },
            params
        ) {
            API.makePost(endpoints.baseURL + API.processUrl(endpoints.endpoints.updateManager, {manager_id: params.managerId}), {
                'firstname': params.firstname,
                'lastname': params.lastname,
                'function': params.function,
                'email': params.mail,
                'phone_number': params.phone_number,
                'address': params.address,
                'city': params.city,
                'postal_code': params.postal_code,
                'fb_link': params.fb_link
            }, true).then(response => { // commit('setUsersData', response);
                dispatch('userData');
                commit('ui/triggerAlert', {
                    type: 'success',
                    msg: 'Manager modifié avec succès'
                }, {root: true});
            }).catch(error => {
                let m = error.response ? error.response.data : (error.request ? error.request.response : error.message);
                commit('setUsersError', m.error);
                params.error(error);
                commit('ui/triggerAlert', {
                    type: 'error',
                    msg: 'La modification du manager a échoué'
                }, {root: true});
                return error;
            })
        },

        createManager({
            commit
        }, params) {
            API.makePost(endpoints.baseURL + endpoints.endpoints.createManager, {
                'firstname': params.firstname,
                'lastname': params.lastname,
                'phone_number': params.phone,
                'email': params.mail,
                'function': params.function,
                'address': params.address,
                'city': params.city,
                'postal_code': params.postal_code,
                'fb_link': params.socialFacebook
            }, true).then(response => {
                commit('setUsersData', response.data.payload);
                commit('ui/triggerAlert', {
                    type: 'success',
                    msg: 'Manager modifié avec succès'
                }, {root: true});
            }).catch(error => {
                let m = error.response ? error.response.data : (error.request ? error.request.response : error.message);
                commit('setUsersError', m.error);
                params.error(error);
                commit('ui/triggerAlert', {
                    type: 'error',
                    msg: 'La modification du manager a échoué'
                }, {root: true});
                return error;
            })
        },

        login(state, params) {
            state.commit('ui/cloader', {
                display: true,
                label: ''
            }, {root: true});
            API.makePost(endpoints.baseURL + endpoints.endpoints.login, {
                'email': params.email,
                'password': params.password
            }, false).then(response => {
                try {
                    state.commit('storeTokenInCookie', response.data.payload.token);
                    params.success();
                } catch (e) {
                    console.error(e);
                }
            }).catch(error => {
                let m = error.response ? error.response.data : (error.request ? error.request.response : error.message);
                state.commit('setUsersError', m.error);
                params.error(error);
            })
        },

        register(
            {
                dispatch,
                commit
            },
            {params}
        ) {
            API.makeFormDataPost(endpoints.baseURL + endpoints.endpoints.register, {
                'firstname': params.firstname,
                'lastname': params.lastname,
                'email': params.email,
                'password': params.password
            }, false).then(response => {
                commit('storeTokenInCookie', response.data.payload.token);
                commit('ui/triggerAlert', {
                    type: 'success',
                    msg: 'Utilisateur enregistré'
                }, {root: true});
            }).catch(error => {
                let m = error.response ? error.response.data : (error.request ? error.request.response : error.message);
                commit('setUsersError', m.error);
                params.error(error);
                commit('ui/triggerAlert', {
                    type: 'error',
                    msg: 'Erreur d\'enregistrement de l\'utilisateur'
                }, {root: true});
                return error;
            })
        },


        refreshToken(
            {commit, dispatch, state}
        ) {
            API.makePost(endpoints.baseURL + endpoints.endpoints.refreshToken, {}, true).then(response => {
                commit('storeTokenInCookie', response.data.payload.token);
                let ttl = getTokenTTL(window.$cookies.get(process.env.VUE_APP_COOKIE_NAME));
                setTimeout(() => {
                    dispatch('refreshToken');
                }, Math.max(0, (ttl - (60 * 60 * 3)) * 1000));
            }).catch(response => {
                dispatch('ui/triggerSnackbarError', "Votre session est sur le point d'expirer, nous n'avons pas pu vous reconnecter", {root: true});
            });
        },
        passwordResetRequest(
            {
                commit,
                state,
                dispatch
            },
            parameters
        ) {

            if (['', null].includes(parameters.parameters.email)) {
                commit('ui/triggerAlert', {
                    type: 'error',
                    msg: "Merci de renseigner votre email."
                }, {root: true});
                return;
            }

            if (state.passwordRequest) {
                return;
            }

            commit('setPasswordRequest', true);
            // commit('ui/setApplicationLoadOn', null, { root : true});
            API.makePost(endpoints.baseURL + endpoints.endpoints.requestNewPassword, {
                email: parameters.parameters.email
            }, false).then(response => {
                commit('ui/triggerAlert', {
                    type: 'success',
                    msg: "Une demande a été envoyée à l'adresse : " + parameters.parameters.email
                }, {root: true});
                parameters.success(response.data.payload);
            }).catch(error => {
                commit('ui/triggerAlert', {
                    type: 'error',
                    msg: "Nous n'avons pas pu traiter votre demande."
                }, {root: true});
            }). finally(response => {
                commit('setPasswordRequest', false);
                // commit('ui/setApplicationLoadOff', null, { root : true});
            });
        },
        passwordResetPerform(
            {
                commit,
                state,
                dispatch
            },
            parameters
        ) {
            if (state.passwordRequest) {
                return;
            }
            commit('set_processing', true);
            commit('ui/setApplicationLoadOn', null, {root: true});
            API.makePost(endpoints.baseURL + endpoints.endpoints.passwordResetPerform, {
                email: parameters.parameters.email,
                reset: parameters.parameters.reset,
                password: parameters.parameters.password
            }, false).then(response => {
                dispatch('ui/triggerSnackbarSuccess', "Mot de passe mis à jour, vous pouvez vous connecter.", {root: true});
                parameters.success(response.data.payload);
            }).catch(error => {
                dispatch('ui/triggerSnackbarError', "Une erreur est survenue, nous n'avons pas pu réinitialiser votre mot de passe.", {root: true});
            }). finally(response => {
                commit('set_processing', false);
                commit('ui/setApplicationLoadOff', null, {root: true});
            });
        },
        updateUserProfile(
            {
                commit,
                state,
                dispatch
            },
            parameters
        ) {
            if (state.processing) {
                return;
            }
            commit('set_processing', true);
            commit('ui/setApplicationLoadOn', null, {root: true});
            API.makeFormDataPost(endpoints.baseURL + endpoints.endpoints.updateUserProfile, parameters.parameters, true).then(response => {
                dispatch('ui/triggerSnackbarSuccess', "Votre profil a été mis à jour.", {root: true});
                parameters.success(response.data.payload);
            }).catch(error => {
                dispatch('ui/triggerSnackbarError', "Une erreur est survenue lors de la mise à jour du profil", {root: true});
            }). finally(response => {
                commit('set_processing', false);
                commit('ui/setApplicationLoadOff', null, {root: true});
            });
        },
        logout(
            {
                commit,
                state,
                dispatch
            },
            parameters
        ) {
            if (state.processing) {
                return;
            }
            commit('set_processing', true);
            commit('ui/setApplicationLoadOn', null, {root: true});
            API.makePost(endpoints.baseURL + endpoints.endpoints.logout, {}, true). finally(response => {
                commit('set_processing', false);
                commit('ui/setApplicationLoadOff', null, {root: true});
                dispatch('ui/triggerSnackbarSuccess', "A bientôt!", {root: true});
                commit('logoutUser');
            })
        }
    }
};
